import { useEffect, useState } from 'react'
import { useTheme } from 'next-themes'

export function ThemeColorManager() {
  const { theme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return

    // Use resolvedTheme to get the actual applied theme (system preference resolved)
    const effectiveTheme = resolvedTheme || theme
    const themeColor = effectiveTheme === 'dark' ? '#0a0a0a' : '#FFFFFF'

    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', themeColor)
  }, [theme, resolvedTheme, mounted])

  return null
}
